import { useQuery } from '@tanstack/react-query';
import { ambientApi } from 'src/services';
import { Encounter } from 'src/models';

export type UseGetEncounterListParams = {
  patientId: number | string;
};

export type GetEncounterListResponse = {
  encounters: Encounter[];
  page: number;
  pages: number;
  per_page: number;
  total: number;
};

export const useGetEncounterList = ({
  patientId,
}: UseGetEncounterListParams) => {
  return useQuery({
    queryKey: ['encounterList', patientId],
    queryFn: () =>
      ambientApi
        .get<GetEncounterListResponse>('/encounters', {
          params: { patient_id: patientId },
        })
        .then((res) => res.data),
  });
};
